import React from 'react'
import PropTypes from 'prop-types'
import { GenericHelp } from '/components/common'

import api from 'services/api'
import { incrementCurrentAttempts } from 'services/smsAttempts'
import './index.less'

import MaskedInput from 'antd-mask-input'

import { Typography, Button, Row, Col, Icon, Form, message, Alert } from 'antd'
import { useEffect, useState } from 'react'
const { Text } = Typography

const alreadyHaveACode = (isPreviewComponent, smsSentCallback) => (
  <div>
    Já tem um código?
    <strong
      onClick={
        !isPreviewComponent
          ? () => smsSentCallback({ canSendANewSms: true })
          : undefined
      }
      style={{ cursor: 'pointer' }}
    >
      {' '}
      Clique aqui
    </strong>
  </div>
)

export const Sms = ({ isPreviewComponent, smsSentCallback, pin }) => {
  const [phone, setPhone] = useState('')
  const [isSubmitting, setSubmitting] = useState(false)

  let progressInterval = null

  useEffect(() => {
    if (localStorage.getItem('timerBeforeNextSms')) {
      progressInterval = setInterval(checkProgress, 1000)
    } else {
      return
    }
  }, [])

  const checkProgress = () => {
    const timerBeforeNextSms = localStorage.getItem('timerBeforeNextSms')

    if (timerBeforeNextSms <= Date.now()) {
      clearInterval(progressInterval)
      localStorage.removeItem('timerBeforeNextSms')
    }
  }

  const handleChange = e => {
    setPhone(e.target.value)
  }

  const handleSubmit = async e => {
    e.preventDefault()

    if (isPreviewComponent) return
    else {
      setSubmitting(true)

      const normalizedNumber = phone
        .normalize('NFD')
        .replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '')
      try {
        const { data } = await api.post(`/delivery-bundle/${pin}/sms`, {
          number: normalizedNumber,
        })

        if (data.code === 'LimitExceeded') {
          message.error(
            'Limite de envios excedido. Por favor, entre em contato com o suporte.',
          )
        } else if (data.error) {
          message.error(
            'Ocorreu um erro interno. Por favor, tente novamente em alguns minutos',
          )
        } else {
          smsSentCallback({ canSendANewSms: false })
        }

        incrementCurrentAttempts()
      } catch (error) {
        message.error(
          'Ocorreu um erro interno. Por favor, tente novamente em alguns minutos',
        )
      }

      setSubmitting(false)
    }
  }

  return (
    <Row style={{ height: '100%' }}>
      <Col
        xs={{ span: 20, offset: 2 }}
        lg={{ span: 13, offset: 7 }}
        xl={{ offset: 7 }}
        xxl={{ offset: 6 }}
        id='sms-form'
      >
        <Text style={{ fontSize: 20 }}>
          Para acessar o PIN é necessário validar seu número de celular através
          de um SMS
        </Text>

        <Form onSubmit={handleSubmit}>
          <MaskedInput
            prefix={<Icon type='phone' theme='filled' />}
            mask='+(55) (11) 11111-1111'
            name='phone'
            onChange={handleChange}
            value={phone}
            style={{ margin: '1em 0' }}
            size='large'
            required={isPreviewComponent ? false : true}
            inputMode='numeric'
            id='phone-input'
          />
          <Alert
            style={{ margin: '-0.5em 0 0.5em' }}
            message={alreadyHaveACode(isPreviewComponent, smsSentCallback)}
            type='warning'
            showIcon
          />
          <Button
            type='primary'
            htmlType='submit'
            id='submit'
            className='btn'
            block
            loading={isSubmitting}
          >
            Enviar
          </Button>
        </Form>

        <GenericHelp />
      </Col>
    </Row>
  )
}

Sms.propTypes = {
  /** If this component was rendered by the preview component */
  isPreviewComponent: PropTypes.bool,

  /** Callback to be executed once the SMS is sucessfully sent */
  smsSentCallback: PropTypes.func,

  /** Delivery bundle pin */
  pin: PropTypes.string,
}
